import { createFileRoute, Outlet } from "@tanstack/react-router";
import FirebaseRedirectHandler from "src/components/app/FirebaseRedirectHandler/FirebaseRedirectHandler";
import AuthGate from "src/components/auth/AuthGate/AuthGate";
import { getBrowserLocale } from "src/server/functions/BrowserLocale";

// Pages that need a session: signed-out visitors get the sign-in page in place of the content, at
// the same URL. Everything here, the sign-in page included, is in the person's language: the root
// document reads `browserLocale` (src/routes/__root.tsx), and the person's saved choice wins.
export const Route = createFileRoute("/_authed")({
  loader: async () => ({ browserLocale: await getBrowserLocale() }),
  staleTime: Number.POSITIVE_INFINITY,
  component: AuthedLayout,
});

function AuthedLayout() {
  return (
    <>
      <FirebaseRedirectHandler />
      <AuthGate>
        <Outlet />
      </AuthGate>
    </>
  );
}
